import { render } from "./PromptAdd.vue?vue&type=template&id=529734db"
import script from "./PromptAdd.vue?vue&type=script&lang=js"
export * from "./PromptAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__